import "./Pop-up-container.css";
import { useEffect } from "react";
import ReactDOM from "react-dom";

/**
 * How many popups are open, and whether WE are the ones holding the lock.
 *
 * Two separate problems this solves, both of which showed up as "the page
 * behind the modal scrolls" or "the page can never scroll again":
 *
 * 1. NESTING. The notifications bell can open a related-operation modal on top
 *    of a page's own popup, and the composer opens one from inside another.
 *    Without a count, the first to unmount clears body.overflow while the
 *    other is still open. (The admin app already counts; this one did not.)
 *
 * 2. UNRELATED WRITERS. UsersNavBar and SideBarOverly write the same property
 *    for the mobile drawer. The drawer closing used to run
 *    `body.style.overflow = ""` and unlock the page underneath an open modal.
 *    They now defer to this flag instead of clearing it blindly.
 */
let openPopupCount = 0;

export function popupsAreOpen() {
  return openPopupCount > 0;
}

function PopUpContainer({
  displayPopUp,       // Function to set state to false (close popup)
  popUpTitle,         // String for the main title
  popUpSubtitle,      // (Optional) String for the hint/subtitle below title
  popUpIcon,          // (Optional) FontAwesome class, e.g., "fa fa-box"
  popUpClassName,     // (Optional) Extra class for specific targeting
  children            // The actual form/content you want inside the popup
}) {
  
  // Lock the background scroll when the popup is open
  useEffect(() => {
    openPopupCount += 1;
    document.body.style.overflow = "hidden";

    // Unlock only when the LAST popup closes — see the note on openPopupCount.
    return () => {
      openPopupCount = Math.max(0, openPopupCount - 1);
      if (openPopupCount === 0) {
        document.body.style.overflow = "";
      }
    };
  }, []);

  const modalContent = (
    <div className={`premium-modal-overlay ${popUpClassName || ""}`}>
      {/* Clickable backdrop */}
      <div className="pop-up-backdrop" onClick={() => displayPopUp(false)} />
      
      {/* The Glassmorphism Box */}
      <div className="premium-modal-content">
        
        {/* Universal Header */}
        <div className="modal-header">
          <div className="modal-header-left">
            {popUpIcon && (
              <div className="modal-title-icon">
                <i className={popUpIcon}></i>
              </div>
            )}
            <h3>{popUpTitle}</h3>
          </div>
          <button
            className="modal-close-btn"
            onClick={() => displayPopUp(false)}
            aria-label="Close"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>

        {popUpSubtitle && <p className="modal-hint">{popUpSubtitle}</p>}

        <hr className="modal-divider" />

        {/* Dynamic Inner Content */}
        <div className="pop-up-body smooth-display">
          {children}
        </div>
        
      </div>
    </div>
  );

  // Render outside the DOM tree to prevent CSS clipping
  return ReactDOM.createPortal(modalContent, document.body);
}

export default PopUpContainer;